import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../types/results';
import { getAllProducs } from '../../utils/trackings';

interface IShareViaLandingFlags {
  with_notes: boolean;
  with_addresses: boolean;
  with_links: boolean;
}

const FLAGS_KEYS: Array<keyof IShareViaLandingFlags> = ['with_notes', 'with_addresses', 'with_links'];

export const trackSaveSettings = (favoriteEntities: IFavoriteEntity[], options: IShareViaLandingFlags) => {
  const products = getAllProducs({ favoriteEntities });

  const label = FLAGS_KEYS.filter(flagKey => options[flagKey]).join(', ');

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'collection_settings_save',
    label,
    products,
  });
};
